<template>
    <div class="signUp bodyfont-unauth" :class="{ hidden: isHidden() }">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
<!--                    <alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>-->
<!--                        <span class="icon-info-circled alert-icon-float-left"></span>-->
<!--                        <strong>Error:</strong>-->
<!--                        <p id="redeem_errormsg">{{error.message}}</p>-->
<!--                    </alert>-->
                    <div class="row margin-top">
                        <div class="col-md-7">
                            <div class="main-content text-left left-content">
                                <hr>
                                <h2 v-if="getCorporateClient">
                                    {{getGiftee.welcomeMessage}}
                                    <!--<span v-if="getCorporateClientId === '50'">Welcome, Ann Carlsen has given you a 12 Month Membership to TONE Networks. Enjoy your Gift.</span>-->
                                    <!--<span v-else>Welcome, You have received a gift from {{getCorporateClient.name}}.</span>-->
                                </h2>
                            </div>
                            <div class="left-content">
                                <accordion :one-at-atime="true">
                                    <panel :is-open="true"  class="text-left">
                                        <h4>Create your Account</h4>
                                        <!--<h4>Start your Trial. Setup your Account</h4>-->
                                        <div class="create-account">
                                            <br>
                                            <div class="form">
                                                <form  method="post"  v-on:submit.prevent="onGifteeSubmit">

                                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus">
                                                        <bs-input label="First Name" autocomplete="given-name" v-model="user.firstName"
                                                                  v-bind:pattern="/^[A-Za-z '-]+$/"
                                                                  id = "redeem_firstname"
                                                                  type="text"
                                                                  class="form-input"
                                                                  error="First Name (no digits allowed)"
                                                                  placeholder="First Name"
                                                                  required
                                                                  icon>
                                                        </bs-input>
                                                        <bs-input label="Last Name" autocomplete="family-name" v-model="user.lastName"
                                                                  v-bind:pattern="/^[A-Za-z '-]+$/"
                                                                  id = "redeem_lastname"
                                                                  type="text"
                                                                  class="form-input"
                                                                  error="Last Name (no digits allowed)"
                                                                  placeholder="Last Name"
                                                                  required
                                                                  icon>
                                                        </bs-input>
                                                        <bs-input label="Email Address" autocomplete="email" v-model="user.email"
                                                                  :pattern="emailPattern"
                                                                  id = "redeem_email"
                                                                  type="email"
                                                                  class="form-input"
                                                                  error="Email Address"
                                                                  placeholder="Email Address"
                                                                  required
                                                                  icon>
                                                        </bs-input>
                                                        <div v-if="this.corpId=='114'" class="mandatory-class">
                                                            <select aria-label="Region"  v-model="user.userRegion" class="form-control" style="border-color:#a94442">
                                                                <option disabled value="0">Select Which Organization You Are From</option>
                                                                <option value="5">Diverse Segments</option>
                                                                <option value="6">West Division</option>
                                                                <option value="7">Mid West & Mid-Atlantic Division</option>
                                                                <option value="8">New England Division</option>
                                                                <option value="9">South East and South West Division</option>
                                                                <option value="10">New York Division</option>
                                                                <option value="11">Office of Chief Fuduciary</option>
                                                                <option value="12">Wealth Management Banking & Lending</option>
                                                                <option value="13">Private Bank Products, Services & Platforms</option>
                                                                <option value="14">Chief Operating Office</option>
                                                            </select>
                                                            <div class="help-block with-errors" style="color:#a94442">Organization (required)</div>
                                                        </div>
                                                        <label for="signup_password">Password</label>
<vue-password autocomplete="new-password" v-model="user.password"
                                                                      :minlength="6"
                                                                      classes="input form-control"
                                                                      class="form-input"
                                                                      placeholder="Password"
                                                                      error="Password"
                                                                      id = "signup_password"
                                                                      :disableStrength = "hidePasswordMeter"
                                                                      required
                                                                      icon
                                                        >
                                                        </vue-password>
                                                        <span  class="icon-info-circled alert-icon-float-left information">
                                                        <p class="alert alert-info alert-dismissable"  id="redeem_pwderrormsg" :class = "{'set-error': !verifyPassword()}">Min 6 Chars, One Upper Case, One Lower Case!</p>
                                                        </span>
                                                        <checkbox class="terms-and-condition" v-model="isChecked" value="isChecked" type="primary">
                                                            &nbsp;I agree to <a href="/terms" target="_blank" rel="opener" :style="{color: getCorpHeaderColor}">terms and conditions</a>
                                                            <!--I agree to-->
                                                            <!--<router-link  :to="{ path: '/terms'}">-->
                                                                <!--terms and conditions-->
                                                            <!--</router-link>-->
                                                        </checkbox>
                                                    </div>
                                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right">
                                                        <!--<button class="btn formButton btn-block" type="submit" id="signup_button" :disabled="isUserLoggedIn">-->
                                                        <button  v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn formButton btn-block" type="submit" id="redeem_button"
                                                        :disabled = "!isChecked || spinner || this.user.packageId === -1 || (this.corpId=='114' ?  this.user.userRegion < 1 : false) ">
                                                            Complete Sign Up
                                                            <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </panel>
                                </accordion>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="right-content">
                                <div class="jumbotron" v-bind:style="{ backgroundColor: getCorpButtonColor}">
<!--                                    <div v-if="getGiftee.panelHeading1"><h2>{{getGiftee.panelHeading1}}</h2></div>&ndash;&gt;-->
                                    <div class="hidemobile"><h2 v-if="getGiftee.panelHeading1">{{getGiftee.panelHeading1}}</h2><p v-if="getGiftee.panelHeading2">{{getGiftee.panelHeading2}}</p></div>
                                    <div class="showmobile"><h2 v-if="getGiftee.panelHeading2">{{getGiftee.panelHeading2}}</h2></div>
                                </div>
                            </div>
                            <div class="right-content">
                                <div class="card">
                                    <!--<div class="card-header text-center">-->
                                        <!--<h3>-->
                                            <!--YOUR PLAN-->
                                        <!--</h3>-->
                                    <!--</div>-->
                                    <div class="card-block">
                                        <div class="list-group">
                                            <li v-if="getGiftee.panelBullet1" v-html="getGiftee.panelBullet1">
                                                <!--Personalized bite-sized expert-->
                                                <!--videos will inspire you and set a positive-->
                                                <!--TONE to your day-->
                                            </li>
                                            <li  v-if="getGiftee.panelBullet2" v-html="getGiftee.panelBullet2">
                                                <!--A little dose of humor, and a pinch-->
                                                <!--of inspiration each time you log on.-->
                                            </li>
                                            <li v-if="getGiftee.panelBullet3" v-html="getGiftee.panelBullet3">
                                                <!--Reserve your spot for TONE Live...-->
                                                <!--Exclusive live streaming events with our-->
                                                <!--credentialed experts.-->
                                            </li>
                                            <li v-if="getGiftee.panelBullet4" v-html="getGiftee.panelBullet4">
                                                <!--Tune in to TONE Talks...our moderated-->
                                                <!--discussions every Tuesday and Thursday night-->
                                                <!--where we share advice within our community-->
                                                <!--of women helping women!-->
                                            </li>
                                            <li v-if="getGiftee.panelBullet5" v-html="getGiftee.panelBullet5">
                                                <!--Most importantly, make time for you!-->
                                            </li>
                                            <li v-if="getGiftee.panelBullet6" v-html="getGiftee.panelBullet6">
                                                <!--Enjoy your gift!-->
                                            </li>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="card-footer hidemobile" >
                                        <div class="list-group">
                                            <li class="list-group-item" v-if="giftDescription">
                                                <strong>{{giftDescription}}</strong>
                                                <!--<input type="radio" name = "pkg" :value="defaultPlan.packageId" v-model="packageId" :checked="defaultPlan.packageId == packageId" />&nbsp;&nbsp;<strong>{{ defaultPlan.type }}</strong> (${{defaultPlan.amount}}) - {{defaultPlan.description}}-->
                                            </li>
                                            <li class="list-group-item" v-else>
                                                <strong>{{defaultPlan.description}}</strong>
                                            </li>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal v-if="showResetModal" class="watchVideoModal" effect="zoom" :value="showResetModal" @cancel="cancelResetModal()" width="200">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a>
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a v-a11y-action href="javascript:" @click="cancelResetModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">


                <div class="text-center">
                    <h2 class="forgot-heading">
                        That Account Exists!
                    </h2>
                    <p><strong>You have an account with Tone Networks. Please try logging in or resetting your password.</strong></p>
                    <button class="btn formButton btn-transparent" @click="SetupLogin">
                        Sign In
                    </button>
                    <button class="btn formButton btn-transparent" @click="onSubmitForgetRequest">
                        Reset Password
                    </button>
                    <!--                    <button class="btn formButton btn-transparent" @click="cancelResetModal()">-->
                    <!--                        Go Back-->
                    <!--                    </button>-->
                </div>
            </div>
            <div slot="modal-footer">
            </div>
        </modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { accordion, dropdown, radio, tab, buttonGroup } from 'vue-strap'
    import spinner from '@/accessibility/Spinner'
    import panel from '@/accessibility/Panel'
    import alert from '@/accessibility/Alert'
    import tabs from '@/accessibility/Tabs'
    import input from '@/accessibility/Input'
    import checkbox from '@/accessibility/Checkbox'
    import modal from '@/accessibility/Modal'
    import VuePassword from '@/accessibility/Password'
    import MaskedInput from 'vue-masked-input'
    import store from '../store'
    import $ from 'jquery'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'accordion': accordion,
            'panel': panel,
            'masked-input': MaskedInput,
            alert,
            dropdown,
            radio,
            VuePassword,
            checkbox,
            tabs,
            tab,
            buttonGroup,
            modal
        },
        name: 'signUp',
        metaInfo () {
            return {
                title: 'TONE | Redeem Your Gift',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Redeem Your Gift'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks is a highly personalized, online learning and coaching platform designed to develop early to mid-career professionals thrive in an increasingly competitive workplace.'
                    },
                    {property: 'twitter:title', content: 'TONE | Redeem Your Gift'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                user: {
                    userId: 0,
                    email: '',
                    password: '',
                    firstName: '',
                    lastName: '',
                    packageId: 0,
                    comments: '',
                    phoneNumber: '',
                    picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/Sneakers.png',
                    userRegion: 0
                },
                emailPattern: "^[a-zA-Z0-9._%+'\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}(\\.[a-zA-Z]{2,})?$",
                showMobileFlag: true,
                phoneNumber: '',
                rawPhoneNumber: '',
                spinner: false,
                alert: false,
                passwordError: '',
                paymentSection: false,
                isToggle: false,
                isChecked: false,
                defaultPlan: '',
                hidePasswordMeter: true,
                corpGiftCode: this.$route.params.giftCode,
                corpId: this.$route.params.corporateId,
                corpRegion: this.$route.params.regions,
                dynamic_bullet_1: '',
                dynamic_bullet_2: '',
                dynamic_bullet_3: '',
                dynamic_bullet_4: '',
                dynamic_bullet_5: '',
                dynamic_bullet_6: '',
                giftDescription: '',
                showResetModal: false
            }
        },
        mounted () {
            // --------------------- 10/06/2021 --------------------- changes ---------- starts here ---------------------------
            console.log('inside CorporationGifting.vue -> mounted () ----------------------> this.corpId', this.corpId)
            console.log('inside CorporationGifting.vue -> mounted () ----------------------> this.$route.params.corporateId', this.$route.params.corporateId)
            console.log('inside CorporationGifting.vue -> mounted () ----------------------> typeof this.corpId', typeof this.corpId)
            console.log('inside CorporationGifting.vue -> mounted () ----------------------> typeof this.$route.params.corporateId', typeof this.$route.params.corporateId)
            const corporateCorporationId = typeof this.corpId === 'number' ? this.corpId.toString() : this.corpId
            if (corporateCorporationId === '200' || this.$route.params.corporateId === '200') {
                // this.$router.push('/horizonsso/sso1data')
                this.$router.push('/horizonsso?no_assertion_found=true')
            } else if (corporateCorporationId === '112' || this.$route.params.corporateId === '112') {
                this.$router.push(`/corporationgiftingcustom/112/COMCAST`)
            } else if (corporateCorporationId === '197' || this.$route.params.corporateId === '197') {
                this.$router.push(`/corporationgiftingcustom/197/ADECCO`)
            } else if (this.isUserLoggedIn && this.isUserLoggedIn.userId > 0) {
                console.log('user is logged in')
                this.$router.push('/mytone')
            } else {
                this.$store.dispatch('GETDYNAMICCONTENTS', 4).then(() => {
                    if (this.getAllSiteContents) {
                        this.dynamic_bullet_1 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_1')
                        this.dynamic_bullet_2 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_2')
                        this.dynamic_bullet_3 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_3')
                        this.dynamic_bullet_4 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_4')
                        this.dynamic_bullet_5 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_5')
                        this.dynamic_bullet_6 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_6')
                    }
                })
                let giftPayload = []
                giftPayload.push(this.corpGiftCode)
                giftPayload.push(this.corpId)
                if (this.$route.params.giftCode && this.$route.params.corporateId) {
                    this.$store.commit('setCorporateGiftingCode', {giftCode: this.$route.params.giftCode})
                    this.$store.commit('setCorporateClientId', {corporateClientId: this.$route.params.corporateId})
                } else {
                    this.$router.push('/')
                }
                this.$store.dispatch('GETCORPORATECLIENT', this.$route.params.corporateId).then(() => {
                    if (this.getCorporateClient) {
                        if (this.getCorporateClient.phoneFlag === 2 || this.getCorporateClient.phoneFlag === 4) {
                            this.showMobileFlag = false
                        }
                    }
                })
                this.$store.dispatch('GETCORPORATIONGIFTEE', giftPayload).then(() => {
                    if (this.getGiftee) {
                        console.log('giftee info', this.getGiftee)
                        this.$store.commit('setCorporateGiftInfo', {gift: this.getGiftee})
                        this.user.firstName = this.getGiftee.gifteeFirstName
                        this.user.lastName = this.getGiftee.gifteeLastName
                        this.user.email = this.getGiftee.gifteeEmail
                        this.user.packageId = this.getGiftee.packageId
                        this.user.comments = this.getGiftee.gifteeUuid
                        this.giftDescription = this.getGiftee.signupGiftDesc
                    } else {
                        if (this.getGiftingError.show) {
                            this.user.packageId = -1
                            this.$swal({
                                title: 'You have reached the maximum number of accounts registered for this trial offer.',
                                text: '',
                                type: 'error',
                                timer: 4000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                        }
                    }
                    this.$store.dispatch('GETPLANS').then(() => {
                        let plan = this.getAllPlans.filter(pln => {
                            return pln.packageId === this.getGiftee.packageId
                        })
                        this.defaultPlan = plan[0]
                    })
                })
            }
        },
        methods: {
            SetupLogin () {
                this.showResetModal = false
                store.commit('setTriggerLogin', {loginStatus: true})
            },
            cancelResetModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showResetModal = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            onSubmitForgetRequest () {
                var self = this
                console.log('email', self.user.email)
                // this.spinnerToggle()
                this.$store.dispatch('FORGOTPASSWORD', {user: self.user}).then(() => {
                    // this.spinnerToggle()
                    if (self.error.show) {
                        self.$swal({
                            title: self.error.message,
                            text: '',
                            type: 'error',
                            timer: 2000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                                self.showResetModal = false
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                    self.cancelResetModal()
                                }
                            }
                        )
                    } else {
                        self.$swal({
                            title: 'Forgot Password Request Sent! Check your email and follow the reset link',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                    self.cancelResetModal()
                                }
                            }
                        )
                    }
                })
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            verifyPaymentSubmit () {
                if (this.user.packageId > 0) {
                    return false
                }
                return true
            },
            verifyPassword () {
                if (this.user.password.length >= 6) {
                    let re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/
                    if (!re.test(this.user.password)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    if (this.user.password.length > 0) {
                        return false
                    } else {
                        return true
                    }
                }
//                if (this.user.password.length >= 6) {
//                    let re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/
//                    if (!re.test(this.user.password)) {
//                        this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!'
//                        return false
//                    } else {
//                        return true
//                    }
//                } else {
//                    return false
//                }
            },
            verifyEmail () {
                if (this.user.email.length > 0) {
                    let re = /^[\w\d.+'-]+@[\w\d-]+(\.[\w\d-]+)*\.[a-z]+$/i
                    if (!re.test(this.user.email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyFirstName () {
                if (this.user.firstName.length > 0) {
                    let re = /^[A-Za-z '-]+$/
                    if (!re.test(this.user.firstName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyLastName () {
                if (this.user.lastName.length > 0) {
                    let re = /^[A-Za-z '-]+$/
                    if (!re.test(this.user.lastName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyCardHolderName () {
                if (this.user.cardHolderName.length > 0) {
                    let re = /^[A-Za-z ]+$/
                    if (!re.test(this.user.cardHolderName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            onGifteeSubmit () {
                const url = window.location.href
                const region = url.split('/').pop()
                console.log('CorporationGifting.vue : region : ', region)
                console.log('CorporationGifting.vue : this.corpId : ', this.corpId)
                if (this.corpId === '93') {
                    if (region === 'Leaders') {
                        this.user.userRegion = 15
                    } else {
                        if (region === 'Mentors') {
                            this.user.userRegion = 16
                        } else {
                            this.user.userRegion = null
                        }
                    }
                }
                if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                    this.user.phoneNumber = this.phoneNumber
                } else {
                    this.phoneNumber = ''
                    this.user.phoneNumber = ''
                }
                let giftPayload = []
                giftPayload.push(this.corpGiftCode)
                giftPayload.push(this.corpId)
                console.log('CorporationGifting.vue : this.corpGiftCode : ', this.corpGiftCode)
                console.log('CorporationGifting.vue : this.corpId : ', this.corpId)
                let displayMsg = 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don�t see it? Check your spam folder.)'
                if (this.corpGiftCode.toLowerCase() === 'GIANTALLACCESS'.toLowerCase()) {
                    displayMsg = 'Welcome To TONE! Now you have access to TONE\'s short-form videos and live coaching events till midnight on March 10th 2021.'
                }
                this.$store.dispatch('GETCORPORATIONGIFTEE', giftPayload).then(() => {
                    let self = this
                    if (this.getGiftee && !this.getGiftingError.show) {
                        if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                            this.spinnerToggle()
                            this.user.email = this.user.email.toLowerCase()
                            this.$store.dispatch('SAVEGIFTEE', {giftee: this.user}).then(() => {
                                if (!this.error.show) {
                                    this.$store.commit('setCorporateGiftingCode', {giftCode: null})
                                    this.$store.commit('setCorporateClientId', {corporateClientId: null})
                                    this.$store.commit('setCorporateGiftingCode', {giftCode: null})
                                    this.$store.commit('setCorporateGiftInfo', {gift: null})
                                    this.spinnerToggle()
                                    this.$swal({
                                        title: 'Registration Success!',
                                        text: displayMsg,
                                        type: 'success',
                                        timer: 4000,
                                        showCancelButton: false,
                                        showConfirmButton: false,
                                        customClass: 'sweetalert-lg-signup'
                                    }).then(
                                        function () {
                                        },
                                        // handling the promise rejection
                                        function (dismiss) {
                                            if (dismiss === 'timer') {
                                            }
                                        }
                                    )
                                } else {
                                    this.spinnerToggle()
                                    if (this.error.show) {
                                        // console.log('error', this.error.message)
                                        if (this.error.message.toString().toLowerCase().indexOf('already exist') > -1) {
                                            self.showResetModal = true
                                            // self.$fire({
                                            //     title: 'That Account Exists',
                                            //     width: 600,
                                            //     text: '',
                                            //     html: '<span font-size:24px;!important"><strong>You have an account with Tone Networks. Please try logging in or resetting your password.</strong></span><br><br>',
                                            //     showCancelButton: true,
                                            //     confirmButtonColor: '#44bda8',
                                            //     cancelButtonColor: '#44bda8',
                                            //     confirmButtonText: '   Sign In   ',
                                            //     cancelButtonText: 'Reset Password',
                                            //     showCloseButton: true
                                            // }).then((result) => {
                                            //     if (result.value) {
                                            //         store.commit('setTriggerLogin', {loginStatus: true})
                                            //     } else if (result.dismiss === 'cancel') {
                                            //         self.onSubmitForgetRequest()
                                            //     }
                                            // })
                                            // let msg = '<p> style='font-size: 18px;font-weight: 500;'>Try logging in with your account credentials. If you\'ve forgotten your account credentials, try resetting your account on the login page.</p>
                                            // self.$swal({
                                            //     title: 'That Account Exists',
                                            //     text: '',
                                            //     type: 'error',
                                            //     html: '<span font-size:24px;">You have an account with Tone Networks. Please try signing in</span>',
                                            //     showCancelButton: true,
                                            //     showCloseButton: true,
                                            //     confirmButtonText: 'Sign In',
                                            //     cancelButtonText: 'Go Back',
                                            //     confirmButtonClass: 'btn btn-lg btn-success',
                                            //     cancelButtonClass: 'btn btn-lg btn-info',
                                            //     buttonsStyling: false
                                            // }).then(function (result) {
                                            //     store.commit('setTriggerLogin', {loginStatus: true})
                                            // }, function (dismiss) {
                                            //     console.log('dismissed')
                                            // })
                                        } else {
                                            this.$swal({
                                                title: 'An Error occurred while processing the request',
                                                text: this.error.message,
                                                type: 'error',
                                                timer: 3000,
                                                showCancelButton: false,
                                                showConfirmButton: false
                                            }).then(
                                                function () {
                                                },
                                                // handling the promise rejection
                                                function (dismiss) {
                                                    if (dismiss === 'timer') {
                                                    }
                                                }
                                            )
                                        }
                                    }
                                }
                            })
                        }
                    } else {
                        this.user.packageId = -1
                        this.$swal({
                            title: 'You have reached the maximum number of accounts registered for this trial offer.',
                            text: '',
                            type: 'error',
                            timer: 4000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    }
                })
            },
            isHidden () {
                // let self = this
                return this.corpId === '200' || this.$route.params.corporateId === '200'
            }
        },
        computed: {...mapGetters([
            'error', 'isUserLoggedIn', 'getAllPlans', 'getGiftee', 'getGiftingError', 'getCorporateGiftingCode', 'getCorporateClientId', 'getCorporateClient', 'getAllSiteContents', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getCorporateGiftInfo'])
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .set-error{
        border-color: #a94442 !important;
        color:#a94442 !important;
    }
    .StripeElement {
        background-color: white;
        padding: 2em 1em;
        border: 1px solid #ccc;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
        height: 34px;
    }
    .float-right.paymentswitch.btn-group {
        margin: 0 0 30px;
    }
    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
    .radiowrapper {
        padding: 0 35px 35px;
        color: #f0617d;
    }
    .showmobile{
        display:none;
    }
    .stripeholder {
        position: relative;
    }

    i.fa.fa-lock.overlapstripe {
        position: absolute;
        left: 18px;
        top: 10px;
        font-size: 18px;
        color: #b2b8c7;
    }
    @media (max-width:767px){
        .hidemobile{
            display:none;
        }
        .showmobile{
            display:inherit;
        }
        .signUp .left-content h4 {
            font-size: 14px;
            letter-spacing: 0px;
        }

        .signUp .main-content h2 {
            margin: 15px 0;
            line-height: 20px;
            font-size: 18px;
        }

        .signUp #redeem_pwderrormsg {
            margin-bottom: 8px;
            line-height: 1.3;
            letter-spacing: 1px;
        }

        .signUp .left-content .create-account #redeem_button {
            margin: 0;
        }

        .signUp .right-content .jumbotron {
            padding: 6px;
            margin-top: 7px;
        }

        .signUp .right-content .jumbotron h2 {
            margin: 0;
            font-size: 21px;
        }

        .signUp .right-content .jumbotron p {
            display: none;
        }

        .signUp .right-content .card {
            padding: 10px 10px;
        }

        .signUp .right-content .card .card-block .list-group li {
            font-size: 16px;
            margin: 0 0 10px;
        }

        .signUp .left-content hr {
            display: none;
        }

        .row.margin-top {
            margin-top: 0px;
        }

    }

    /* Media query for mobile viewport */
    @media screen and (max-width: 400px) {
        #paypal-button-container {
            width: 100%;
        }
    }

    /* Media query for desktop viewport */
    @media screen and (min-width: 400px) {
        #paypal-button-container {
            width: 250px;
            display: inline-block;
        }
    }
    body .margin-top {
        margin-top: 89px;
        margin-bottom: 70px;
    }
    body .signUp .right-content .card .card-block .list-group{
        margin-bottom:0px;
    }
</style>



// WEBPACK FOOTER //
// CorporationGifting.vue?af87c2f4